import { Location } from '@ftr/contracts/api/location'
import { LocationStatus, VideoStatus } from '@ftr/contracts/type/court'
import { generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'

let locationCounter = 1

export class LocationBuilder extends AbstractBuilder<Location> {
  constructor(repeatable: boolean = false) {
    super({
      id: repeatable ? '112d29d9-3438-4ca0-b514-a106a1530ae0' : generateUuid(),
      name: repeatable ? 'Courtroom 27A' : `Location ${locationCounter++}`,
      courtSystemId: repeatable ? '112d29d9-3438-4ca0-b514-a106a1530ae0' : generateUuid(),
      status: LocationStatus.Active,
      timeZoneId: undefined,
      automaticSttEnabled: false,
      trackIsolationInstallationDate: undefined,
      useDownmixedStt: false,
      description: undefined,
      imageUrl: undefined,
      videoStatus: VideoStatus.Enabled,
    })
  }

  withParent(): LocationBuilder {
    const location = new LocationBuilder().with({ courtSystemId: this.result.courtSystemId }).build()
    return this.with({
      parent: location,
      parentId: location.id,
    })
  }
}
